import { FormControlLabel, Radio, Typography } from "@mui/material";

interface SettingsRadioItemProps {
    label: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
}

const SettingsRadioItem = ({ label, value }: SettingsRadioItemProps) => {
    return (
        <FormControlLabel
            value={value}
            label={<Typography variant="caption">{label}</Typography>}
            control={<Radio sx={{ p: 0.5, ml: 0.5 }} />}
        />
    );
};

export default SettingsRadioItem;
